import styled from '@emotion/styled';
import { css, keyframes } from 'emotion';

import { isEvoWrapped } from '@ezugi/utils/src';

import { WINNER_LIST_ROW_HEIGHT } from './constants';

const HEADER_OFFSET = isEvoWrapped() ? 120 : 40;

const slideUp = keyframes({
  from: {
    top: '100%',
    transform: 'translateY(0)',
  },
  to: {
    top: '0',
    transform: 'translateY(-100%)',
  },
});

export const fadeIn = keyframes({
  from: {
    opacity: 0,
  },
  to: {
    opacity: 1,
  },
});

export const fadeOut = keyframes({
  from: {
    opacity: 1,
  },
  to: {
    opacity: 0,
  },
});

export const AnimationWrapper = styled.div({
  position: 'absolute',
  flexShrink: 0,
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  flexFlow: 'column nowrap',
  opacity: 0,
  willChange: 'transform',
  transformStyle: 'preserve-3d',

  animationName: `${slideUp}, ${fadeIn}`,
  animationDuration: 'var(--duration), 200ms',
  animationTimingFunction: 'linear',
  animationFillMode: 'forwards',
});

export const mobileMultiRowWithFadeOutAnumationClassName = css({
  animationName: `${slideUp}, ${fadeIn}, ${fadeOut}`,
  animationDuration: 'calc(var(--duration) / var(--animationSpeedRate)), 200ms, calc(0.15 * var(--duration))',
  animationDelay: '0ms, 0ms, calc(var(--duration) - (0.15 * var(--duration)))',
});

export const mobileAnimationWrapperClassName = css({
  opacity: 1,
  animation: 'none',
  bottom: 0,
  transform: 'translateY(100%)',
  transition: 'transform 0.5s ease-in-out',
});

export const fadeOutAnimation = css({
  animationName: `${fadeOut}`,
  animationDuration: '.6s !important',
  animationFillMode: 'forwards',
});

export const Container = styled.div({
  width: '100%',
  textTransform: 'none',
  display: 'flex',
  justifyContent: 'center',
  flexFlow: 'row nowrap',
  fontWeight: 'normal',
  textShadow: '1px 1px 1px rgba(0, 0, 0, 0.6)',
  fontSize: '12px',
  position: 'relative',
  overflow: 'hidden',
  color: '#dbdbdb',
  margin: '0 10px',
  fontFamily: "'Montserrat', Roboto, serif",
  maskImage:
    'linear-gradient(to top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 20%, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0) 100%)',
});

export const rowClassName = css({
  padding: '4px',
  maxWidth: '100%',
  textShadow: '1px 1px 1px rgba(0, 0, 0, 0.6)',
  alignItems: 'center',
  display: 'flex',

  '> span:first-of-type': {
    marginRight: '6px',
  },
});

export const mobileRow = css({
  display: 'flex',
  justifyContent: 'end',
  height: `${WINNER_LIST_ROW_HEIGHT}px`,
  '> span': {
    ':first-of-type': {
      textAlign: 'right',
      marginRight: '0',
    },
    ':nth-of-type(2)': {
      marginLeft: '8px',
    },
  },
});

export const desktopClassName = css({
  position: 'absolute',
  left: '0',
  top: '40px',
  height: `calc(100% - ${HEADER_OFFSET}px)`,
  maxWidth: '300px',

  span: {
    display: 'inline-block',
    ':first-of-type': {
      maxWidth: '175px',
    },
  },
});

export const mobileClassName = css({
  minHeight: 'auto',
  height: `${WINNER_LIST_ROW_HEIGHT}px`,
  margin: '0',
  [`${AnimationWrapper}`]: {
    justifyContent: 'center',
  },
});

export const mobileNewStyleClassName = css({
  minHeight: 'auto',
  height: '100%',
  margin: '0',
  [`${AnimationWrapper}`]: {
    justifyContent: 'center',
  },
});

export const overflowClassName = css({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const wlHeaderClassName = css({
  borderBottom: '2px solid #ececec6b',
  marginBottom: '2px',
  paddingBottom: '4px',
  '> svg': {
    filter: 'drop-shadow(1px 0px 1px rgba(0, 0, 0, 0.7))',
    marginLeft: '4px',
  },
  '> span': {
    ':first-of-type': {
      marginRight: '4px',
    },
    ':last-of-type': {
      marginLeft: '8px',
    },
  },
});

export const mobileWlClassName = css({
  borderBottom: 'none',
  marginBottom: '0',
  height: `${WINNER_LIST_ROW_HEIGHT}px`,
});
